import Button from '../ui/Button';
import NumberInput from '../ui/NumberInput';
import { useBookingModal } from './BookingModalContext';
import { toDateString } from '../../lib/bookingApi';

const inputClasses =
  'w-full box-border px-3.5 py-3 border border-hairline rounded-md font-sans text-[14.5px] text-ink bg-white transition-all duration-150 outline-none hover:border-dark-muted focus:border-olive focus:shadow-[0_0_0_3px_rgba(75,94,40,0.15)]';

const labelClasses = 'block text-[11px] font-semibold uppercase tracking-[0.08em] text-muted mb-1.5';

export default function HeroBookingWidget() {
  const { openBooking, draft, setDraft } = useBookingModal();
  const today = toDateString(new Date());
  // Read from the shared draft (not local state) so whatever's typed here is
  // visible to any "Book Now" button elsewhere that opens the modal without
  // its own explicit values.
  const name = draft.name ?? '';
  const checkIn = draft.checkIn ?? '';
  const checkOut = draft.checkOut ?? '';
  const adults = draft.adults ?? 1;
  const kids = draft.kids ?? 0;

  return (
    <div className="bg-paper rounded-xl border border-hairline shadow-[0_24px_64px_rgba(33,32,28,0.35)] px-6 py-6 md:px-7 md:py-7 w-full max-w-[480px]">
      <div className="text-[12px] font-semibold uppercase tracking-[0.12em] text-olive mb-1.5">Reserve your stay</div>
      <h2 className="font-serif font-medium text-[21px] text-ink m-0 mb-5">Check availability</h2>

      <div className="mb-3.5">
        <label htmlFor="hero-name" className={labelClasses}>
          Name
        </label>
        <input
          id="hero-name"
          type="text"
          placeholder="Your full name"
          className={inputClasses}
          value={name}
          onChange={(e) => setDraft({ name: e.target.value })}
        />
      </div>

      <div className="grid grid-cols-2 gap-3.5">
        <div>
          <label htmlFor="hero-checkin" className={labelClasses}>
            Check-in
          </label>
          <input
            id="hero-checkin"
            type="date"
            min={today}
            className={inputClasses}
            value={checkIn}
            onChange={(e) => setDraft({ checkIn: e.target.value })}
          />
        </div>
        <div>
          <label htmlFor="hero-checkout" className={labelClasses}>
            Check-out
          </label>
          <input
            id="hero-checkout"
            type="date"
            min={checkIn || today}
            className={inputClasses}
            value={checkOut}
            onChange={(e) => setDraft({ checkOut: e.target.value })}
          />
        </div>
        <div>
          <label htmlFor="hero-adults" className={labelClasses}>
            Adults
          </label>
          <NumberInput
            id="hero-adults"
            min={1}
            max={9}
            className={inputClasses}
            value={adults}
            onChange={(v) => setDraft({ adults: v })}
          />
        </div>
        <div>
          <label htmlFor="hero-kids" className={labelClasses}>
            Kids (under 12)
          </label>
          <NumberInput
            id="hero-kids"
            min={0}
            className={inputClasses}
            value={kids}
            onChange={(v) => setDraft({ kids: v })}
          />
        </div>
      </div>

      <Button
        variant="olive"
        size="lg"
        className="w-full mt-5"
        onClick={() => openBooking({ name, checkIn, checkOut, adults, kids })}
      >
        Check Availability
      </Button>
    </div>
  );
}
